import { useThemeSlice } from "../ui/StatusBadge.jsx";
import { useSbState, useSetSbState } from "../../logic/stores/navigationStore.js";
import { Ico } from "../icons/icons.jsx";
import { SidebarAccentPicker } from "./SidebarAccentPicker.jsx";
import { Tip } from "../ui/Tooltip.jsx";

export function SidebarProfile({ isOpen, isCollapsed, setHoveredTip, setTipRect }) {
  const { dark, setDark, c, accentHex: A } = useThemeSlice();
  const sbState = useSbState();
  const setSbState = useSetSbState();
  const isCollapsedState = sbState === "collapsed";

  return (
    <div style={{ flexShrink: 0 }}>
      <div style={{ borderTop: `1px solid ${c.sbBdr}` }}>
        <div style={{ display: "flex", alignItems: "stretch", padding: isCollapsed ? "8px 0" : 0, justifyContent: isCollapsed ? "center" : "stretch" }}>
          <Tip setHoveredTip={setHoveredTip} setTipRect={setTipRect} id="collapse-btn" label={isCollapsedState ? "Expand sidebar" : "Collapse sidebar"} side="top" fullWidth={isOpen}>
            <button type="button" onClick={() => setSbState(isCollapsedState ? "open" : "collapsed")} onMouseEnter={(e) => (e.currentTarget.style.background = c.hover)} onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")} style={{ width: isOpen ? "100%" : 28, height: isOpen ? 36 : 28, display: "flex", alignItems: "center", justifyContent: "center", border: "none", background: "transparent", cursor: "pointer", color: c.mid }}>
              <span className="nemo-collapse-btn" style={{ display: "flex", transform: isCollapsedState ? "rotate(180deg)" : "rotate(0deg)" }}>{Ico.panelLeft}</span>
            </button>
          </Tip>
          {isOpen && (
            <>
              <Tip setHoveredTip={setHoveredTip} setTipRect={setTipRect} id="theme-btn" label={dark ? "Light mode" : "Dark mode"} side="top" fullWidth>
                <button type="button" onClick={() => setDark(!dark)} onMouseEnter={(e) => (e.currentTarget.style.background = c.hover)} onMouseLeave={(e) => (e.currentTarget.style.background = dark ? c.aLight : "transparent")} style={{ width: "100%", height: 36, display: "flex", alignItems: "center", justifyContent: "center", border: "none", background: dark ? c.aLight : "transparent", color: dark ? A : c.mid, cursor: "pointer" }}>
                  {dark ? Ico.moon : Ico.sun}
                </button>
              </Tip>
              <Tip setHoveredTip={setHoveredTip} setTipRect={setTipRect} id="bell-btn" label="Notifications" side="top" fullWidth>
                <button type="button" onMouseEnter={(e) => (e.currentTarget.style.background = c.hover)} onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")} style={{ width: "100%", height: 36, display: "flex", alignItems: "center", justifyContent: "center", border: "none", background: "transparent", color: c.mid, cursor: "pointer" }}>
                  {Ico.bell}
                </button>
              </Tip>
              <SidebarAccentPicker setHoveredTip={setHoveredTip} setTipRect={setTipRect} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
